import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {FieldDataDto, TaskDto} from '../../../../../Models/Tasks/General/task.interface';
import {FieldTypesEnum} from '../../../../../Shared/Enum/field-types.enum';

@Component({
  selector: 'app-field-item',
  templateUrl: './field-item.component.html',
  styleUrls: ['./field-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class FieldItemComponent {
  @Input() task?: TaskDto;
  @Input() field!: FieldDataDto;

  @Input() type!: number;
  @Input() menu: string = '';

  @Output() openImage: EventEmitter<void> = new EventEmitter<void>();
  @Output() takeImage: EventEmitter<void> = new EventEmitter<void>();

  @Output() valueChange: EventEmitter<void> = new EventEmitter<void>();

  fieldTypes = FieldTypesEnum;
}
